import { selectionsOrdering } from "../../constants";
export var findSelectionsOrdering = function (template, outcomeType) {
    var orderMap = selectionsOrdering[template];
    return outcomeType && Object.keys(orderMap).filter(function (key) {
        return orderMap[key].find(function (val) {
            return val === outcomeType && key;
        });
    }).shift() || "0";
};
//# sourceMappingURL=findSelectionsOrdering.js.map